import { useState } from "react";
import { Link } from "react-router-dom";
import defaultLogin from "../../../assets/global/header/HeaderLogin/HeaderLoginDefault.svg";
import fillLogin from "../../../assets/global/header/HeaderLogin/HeaderLoginFill.svg";

interface HeaderLoginProps {
  className?: string;
  enableHover?: boolean;
  url?: string;
}

export const HeaderLogin = ({
  className = "",
  enableHover = true,
  url = "/login"
}: HeaderLoginProps): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false);

  const content = (
    <div
      className={`
        relative w-[93px] h-[40px] flex items-center justify-center gap-[8px] rounded-[6px] 
        border border-solid border-[var(--fy-grey)] 
        px-[16px] py-[10px]
        transition-all duration-200
        ${isHovered && window.innerWidth >= 768 ? "bg-[var(--fy-grey)]" : ""}
        [font-family:var(--header-menu-font-family)]
        [font-size:var(--header-menu-font-size)]
        [font-weight:var(--header-menu-font-weight)]
        [letter-spacing:var(--header-menu-letter-spacing)]
        [line-height:var(--header-menu-line-height)]
        ${className}
      `}
      onMouseLeave={() => enableHover && window.innerWidth >= 768 && setIsHovered(false)}
      onMouseEnter={() => enableHover && window.innerWidth >= 768 && setIsHovered(true)}
    >
      <div className="relative w-[13.25px] h-[13.25px]">
        <img
          className="absolute inset-0 transition-opacity duration-200"
          alt="Icon Default"
          src={fillLogin}
          style={{
            opacity: enableHover && isHovered && window.innerWidth >= 768 ? 0 : 1
          }}
        />
        <img
          className="absolute inset-0 transition-opacity duration-200"
          alt="Icon Fill"
          src={defaultLogin}
          style={{
            opacity: enableHover && isHovered && window.innerWidth >= 768 ? 1 : 0
          }}
        />
      </div>

      <div
        className={`
          relative whitespace-nowrap transition-colors duration-200
          ${isHovered && window.innerWidth >= 768 ? "text-[var(--fy-greyfade)]" : "text-[var(--fy-grey)]"}
        `}
      >
        Login
      </div>
    </div>
  );

  if (url) {
    return (
      <Link 
        to={url}
        className="block"
      >
        {content}
      </Link>
    );
  }

  return content;
}; 